import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

function RMSDatePicker(props) {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        disableOpenOnEnter
        autoComplete="off"
        disableToolbar
        variant="inline"
        inputVariant="outlined"
        format="MM/dd/yyyy"
        margin="normal"
        autoOk
        size="small"
        {...props}
        onChange={(date) => props.onChange(null, date)}
      />
    </MuiPickersUtilsProvider>
  );
}

export default RMSDatePicker;
